import { GENRES, REGIONS, YEARS, SORT_OPTIONS, type SortKey } from "@/utils/media";

export interface FilterState {
  region: string;
  year: string;
  genre: string;
  sort: SortKey;
}

interface FilterBarProps {
  value: FilterState;
  onChange: (next: Partial<FilterState>) => void;
  onReset: () => void;
  resultCount: number;
}

function Pill({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
        active
          ? "bg-primary-500 text-background-50 font-medium"
          : "bg-background-100 text-foreground-700 hover:bg-background-200"
      }`}
    >
      {label}
    </button>
  );
}

function FilterGroup({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div>
      <p className="text-xs font-medium text-foreground-500 mb-2">{label}</p>
      <div className="flex flex-wrap gap-1.5">
        {options.map((opt) => (
          <Pill key={opt} active={opt === value} label={opt} onClick={() => onSelect(opt)} />
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({ value, onChange, onReset, resultCount }: FilterBarProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <p className="text-sm text-foreground-600">
          共 <span className="font-semibold text-primary-600">{resultCount}</span> 部作品
        </p>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap transition-colors"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </div>

      <FilterGroup
        label="地区"
        options={REGIONS}
        value={value.region}
        onSelect={(region) => onChange({ region })}
      />
      <FilterGroup
        label="年份"
        options={YEARS}
        value={value.year}
        onSelect={(year) => onChange({ year })}
      />
      <FilterGroup
        label="类型"
        options={GENRES}
        value={value.genre}
        onSelect={(genre) => onChange({ genre })}
      />

      <div>
        <p className="text-xs font-medium text-foreground-500 mb-2">排序方式</p>
        <div className="flex flex-wrap gap-1.5">
          {SORT_OPTIONS.map((opt) => (
            <button
              key={opt.key}
              type="button"
              onClick={() => onChange({ sort: opt.key })}
              className={`px-3 py-1.5 rounded-md text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                opt.key === value.sort
                  ? "bg-accent-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}